import { FOOTAGE_UPLOAD_MAX_BYTES } from 'fym-shared/src/music24/musicVideoApi';

const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const;

/** A file size for the upload line ("1.1 GB", design c2). Pure. */
export function formatBytes(bytes: number): string {
  let value = Math.max(0, bytes);
  let unit = 0;
  while (value >= 1000 && unit < UNITS.length - 1) {
    value /= 1000;
    unit += 1;
  }
  const text = value >= 10 || unit === 0 ? String(Math.round(value)) : value.toFixed(1);
  return `${text} ${UNITS[unit] ?? 'B'}`;
}

/**
 * A size limit of ours for a line of text ("10 GB"). The limits are whole binary units
 * (`10 * 1024 ** 3`), so this counts in steps of 1024 and drops a ".0". Pure.
 */
export function formatSizeLimit(bytes: number): string {
  let value = Math.max(0, bytes);
  let unit = 0;
  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }
  const text = Number.isInteger(value) ? String(value) : value.toFixed(1);
  return `${text} ${UNITS[unit] ?? 'B'}`;
}

/** The cap of one footage upload for the text of the Upload tab (spec: `FOOTAGE_UPLOAD_MAX_BYTES`). */
export const FOOTAGE_UPLOAD_LIMIT_TEXT = formatSizeLimit(FOOTAGE_UPLOAD_MAX_BYTES);
